import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { QppopupComponent } from '../qppopup/qppopup.component';

@Component({
  selector: 'app-paper-evaluatoion',
  templateUrl: './paper-evaluatoion.component.html',
  styleUrls: ['./paper-evaluatoion.component.scss']
})

export class PaperEvaluatoionComponent implements OnInit,AfterViewInit {
  @ViewChild('container')
  containerRef!: ElementRef<HTMLElement>;

  @ViewChild('canvas')
  canvasRef!: ElementRef<HTMLCanvasElement>;
  currentButtonValue: string;
  isPinActive: boolean = false;
  pinCoordinates: { x: number, y: number, value: string,qp: string }[] = [];
  selectedQP: string;
  dialogRef1: MatDialogRef<any>;
  selectedOPCode: any;
  totalValue: number;
  maxvalue: any;
  single = false;
  constructor(private renderer: Renderer2,  private dialog: MatDialog,) {}

  buttton=[
    {
    name:'0'
  },
  {
    name:'1/4'
  },
  {
    name:'1/2'
  },
  {
    name:'1'
  },
  {
    name:'2'
  },
  {
    name:'3'
  },
  {
    name:'4'
  },
  {
    name:'5'
  },
  {
    name:'6'
  },
  {
    name:'7'
  },{
    name:'8'
  },{
    name:'9'
  },
  {
    name:'10'
  },{
    name:'NA'
  }
]
butttona=[{
  name:'✔'
},{
  name:'X'
},{
  name:'T'
}]
questionmapermaster=[{
  Ques:'Q1',
  QM:'2',
  score:'0'
},{
  Ques:'Q2',
  QM:'2',
  score:'0'
},{
  Ques:'Q3',
  QM:'2',
  score:'0'
},{
  Ques:'Q4',
  QM:'5',
  score:'0'
},{
  Ques:'Q5',
  QM:'10',
  score:'0'
},{
  Ques:'Q6',
  QM:'8',
  score:'0'
}]
numbers: number[] = [1, 2, 3, 4, 5,6,7,8,9,10,11,12,13,14,15,16];
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    const container: HTMLElement = this.containerRef.nativeElement;
    const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;

    // Use the container and canvas elements here for further operations
    // For example, you can set the size of the canvas:
    canvas.width = container.offsetWidth;
    canvas.height = container.offsetHeight;
  }
  handleButtonClick(button: string) {
    this.currentButtonValue = button;
    this.isPinActive = true;
    this.totalValue += parseInt(this.currentButtonValue)
    if(this.totalValue > this.maxvalue ){
      this.totalValue = 0;
      alert("totalValue should be less or equel to maxvalue")
    }
    this.questionmapermaster.forEach(element => {
      if(element['Ques'] == this.selectedOPCode){
        element['score'] = this.totalValue.toString();
      }
    });
  }
  handleButtonClickOthers(button: string){
    this.currentButtonValue = button;
    this.isPinActive = true;
    this.single = true;
  }

  handleImageClick(event: MouseEvent) {
    if (this.isPinActive && this.currentButtonValue && this.single == false) {
      const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;
      const canvasRect = canvas.getBoundingClientRect();

      const canvasX = event.clientX - canvasRect.left;
      const canvasY = event.clientY - canvasRect.top;

      const valueElement = this.renderer.createElement('div');
      this.renderer.setStyle(valueElement, 'position', 'absolute');
      this.renderer.setStyle(valueElement, 'left', canvasX + 'px');
      this.renderer.setStyle(valueElement, 'top', canvasY + 'px');
      this.renderer.addClass(valueElement, 'value-element');
      this.renderer.setStyle(valueElement, 'position', 'absolute');
      this.renderer.setStyle(valueElement, 'left', canvasX + 'px');
      this.renderer.setStyle(valueElement, 'top', canvasY + 'px');
      this.renderer.setStyle(valueElement, 'width', '50px');
      this.renderer.setStyle(valueElement, 'height', '50px');
      this.renderer.setStyle(valueElement, 'font-size', '1.2rem');
    // this.renderer.setStyle(valueElement, 'background-color', 'red');
    const result = this.currentButtonValue +','+ this.selectedOPCode;
    this.renderer.setProperty(valueElement, 'textContent',result);
    this.renderer.appendChild(this.containerRef.nativeElement, valueElement);
      this.pinCoordinates.push({ x: canvasX, y: canvasY, value: this.currentButtonValue,qp: this.selectedQP });
      this.isPinActive = false;
    }else if(this.isPinActive && this.currentButtonValue && this.single){
      const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;
      const canvasRect = canvas.getBoundingClientRect();
      const canvasX = event.clientX - canvasRect.left;
      const canvasY = event.clientY - canvasRect.top;
      const valueElement = this.renderer.createElement('div');
      this.renderer.setStyle(valueElement, 'position', 'absolute');
      this.renderer.setStyle(valueElement, 'left', canvasX + 'px');
      this.renderer.setStyle(valueElement, 'top', canvasY + 'px');
      this.renderer.addClass(valueElement, 'value-element');
      this.renderer.setStyle(valueElement, 'position', 'absolute');
      this.renderer.setStyle(valueElement, 'left', canvasX + 'px');
      this.renderer.setStyle(valueElement, 'top', canvasY + 'px');
      this.renderer.setStyle(valueElement, 'width', '50px');
      this.renderer.setStyle(valueElement, 'height', '50px');
      this.renderer.setStyle(valueElement, 'font-size', '1.2rem');
    // this.renderer.setStyle(valueElement, 'background-color', 'red');
    // const result = this.currentButtonValue +','+ this.selectedOPCode;
    this.renderer.setProperty(valueElement, 'textContent',this.currentButtonValue );
    this.renderer.appendChild(this.containerRef.nativeElement, valueElement);
      this.pinCoordinates.push({ x: canvasX, y: canvasY, value: this.currentButtonValue,qp: this.selectedQP });
      this.isPinActive = false;
    }
  }
  QPselection(qp){
    this.totalValue = 0;
    this.maxvalue = qp.QM;
    this.selectedOPCode = qp.Ques;
    if(qp.Ques == 'Q1'){
      this.selectedQP = "../../assets/img/qp1.png"
    }else if(qp.Ques == 'Q2'){
      this.selectedQP = "../../assets/img/qp2.png"
    }else{
      this.selectedQP = ''
    }
    
  }
  opendialog(e){
    this.dialogRef1 = this.dialog.open(QppopupComponent, {
      width: "800px",
      height: "auto",
      data:e
      });
  }
  finishpaper(){
    
  }
  refresh(){
    
  }
}
